export default __webpack_public_path__ + "static/media/40t.b3d606c0.jpg";